var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5002 5.33301C12.224 5.33301 12.0002 5.55687 12.0002 5.83301V7.99967H6.66683H5.8335C5.55735 7.99967 5.3335 8.22353 5.3335 8.49967V10.1663C5.3335 10.4425 5.55735 10.6663 5.8335 10.6663H6.66683V23.9997C6.66683 25.4724 7.86074 26.6663 9.3335 26.6663H22.6668C24.1396 26.6663 25.3335 25.4724 25.3335 23.9997V10.6663H26.1668C26.443 10.6663 26.6668 10.4425 26.6668 10.1663V8.49967C26.6668 8.22353 26.443 7.99967 26.1668 7.99967H25.3335H20.0002V5.83301C20.0002 5.55687 19.7763 5.33301 19.5002 5.33301H12.5002ZM9.3335 10.6663H22.6668V23.9997H9.3335L9.3335 10.6663ZM12.0002 13.833C12.0002 13.5569 12.224 13.333 12.5002 13.333H14.1668C14.443 13.333 14.6668 13.5569 14.6668 13.833V20.833C14.6668 21.1092 14.443 21.333 14.1668 21.333H12.5002C12.224 21.333 12.0002 21.1092 12.0002 20.833V13.833ZM17.8335 13.333C17.5574 13.333 17.3335 13.5569 17.3335 13.833V20.833C17.3335 21.1092 17.5574 21.333 17.8335 21.333H19.5002C19.7763 21.333 20.0002 21.1092 20.0002 20.833V13.833C20.0002 13.5569 19.7763 13.333 19.5002 13.333H17.8335Z",
    fill: "#DB4D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.449aceb5.svg";
export { ForwardRef as ReactComponent };